<template>
  <div class="d-flex justify-content-end">
    <TeacherGroupSchedulePurgeButton
      @button-clicked="deleteSchedule"
    ></TeacherGroupSchedulePurgeButton>
  </div>
</template>

<script>
import TeacherGroupSchedulePurgeButton from "@/modules/school/components/teacher/group/schedule/TeacherGroupSchedulePurgeButton";

export default {
  name: "TeacherGroupScheduleControl",
  components: { TeacherGroupSchedulePurgeButton },
  methods: {
    /**
     * When child emitted on click, calls store to delete group schedule.
     */
    deleteSchedule() {
      const groupId = this.$store.getters.getSelectedTeacherGroup.id;
      console.log(groupId);

      this.$bvModal
        .msgBoxConfirm(this.$t("GROUP.SCHEDULE.DELETECONFIRM"))
        .then((isOk) => {
          console.log(isOk);

          if (isOk) this.attempt(groupId);
          else
            this.$bvToast.toast(this.$t("GROUP.SCHEDULE.DELETE_CANCELLED"), {
              variant: "primary",
            });
        });
    },

    attempt(groupId) {
      this.$store
        .dispatch("deleteTeacherGroupSchedule", {
          id: groupId,
        })
        .then(() => {
          this.$bvModal.msgBoxOk("Schedule is deleted.");
          this.$store.dispatch("clearTeacherGroupScheduleList");
        })
        .catch(() => this.$bvModal.msgBoxOk("Cannot delete Schedule."));
    },
  },
};
</script>

<style scoped></style>
